import { useParams } from 'react-router-dom';
import useUsuarioCadastro from '../../../../hooks/useUsuarioCadastro';
import { Loader } from '../../../../shared/components/Loader';
import Box from '@mui/material/Box';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import Typography from '@mui/material/Typography';
import { Input } from '../../../../shared/components/Input';
import { HeaderFormActions } from '../../../../shared/components/HeaderFormActions';
import { useLocation} from 'react-router-dom';

export default function UsuarioCadastrar() {
  const { id } = useParams();
  const userId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const {
    handleBlur,
    values,
    handleChange,
    errors,
    touched,
    handleSubmit,
    backActions,
    loading,
  } = useUsuarioCadastro(userId);

  return (
    <Loader loading={loading}>
      <HeaderComponent text={'Cadastro'} />
      <Box className='p-3'>
        <form autoComplete='off' onSubmit={handleSubmit} name='customer-detail'>
          <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Box className='col-span-6'>
              <HeaderFormActions backActions={() => backActions()} duploClick={duploClick}/>
            </Box>

            <Typography className='col-span-8' variant='h6'>
              Dados Pessoal
            </Typography>
          </Box>            
            <fieldset disabled={duploClick}>
            <Box className='grid grid-cols-8 gap-7 pt-4'>
            <Input
              label='Nome'
              className='col-span-3'
              name='usu_nome'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.usu_nome && errors.usu_nome ? errors.usu_nome : ''}
              hasError={!!(touched.usu_nome && errors.usu_nome)}
              value={values.usu_nome}
            />
            <Input
              label='Login'
              className='col-span-2'
              name='usu_login'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={
                touched.usu_login && errors.usu_login ? errors.usu_login : ''
              }
              hasError={!!(touched.usu_login && errors.usu_login)}
              value={values.usu_login}
            />
            <Input
              label='Senha'
              className='col-span-3'
              name='senha'
              handleBlur={handleBlur}
              handleChange={handleChange}
              error={touched.senha && errors.senha ? errors.senha : ''}
              hasError={!!(touched.senha && errors.senha)}
              value={values.senha}
            />
          </Box>
          </fieldset>
        </form>
      </Box>
    </Loader>
  );
}
